export default class ResponseBase {
    public statusCode!: number;
}

